<footer
  class="aluprof-footer"
  [class.footer-logged]="IsLogedIn">

  <div class="footer-container">


<!-- PIERWSZY WIERSZ -->

<div class="footer-top">

<!-- LOGO -->

<div class="footer-brand">

<img
  src="../../assets/images/aluprof_biale_logo2.png"
  alt="Aluprof"
  class="footer-logo">

</div>

<!-- WARUNKI -->

<div class="footer-column">

<div class="footer-heading">

  <div class="footer-heading-icon">
    <mat-icon>description</mat-icon>
  </div>

  <h4
    id="warunki"
    [translation]="TranslationEnum.Translation">
    {{ 'warunki' | translate }}
  </h4>

</div>

<div class="footer-links">

  <ng-container *ngFor="let dok of tresci.links">

    <a
      *ngIf="
        dok.ProdGroup == 'b2b_warunki' &&
        dok.Culture == tresci.jezyk
      "
      [href]="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      {{ dok.LangVal }}

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>

  </ng-container>
<a
      
      href="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      Test linku

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>
<a
      
      href="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      Test linku

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>
<a
      
      href="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      Test linku

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>

</div>

</div>

<!-- INFORMACJE -->

<div class="footer-column">

<div class="footer-heading">

  <div class="footer-heading-icon">
    <mat-icon>business</mat-icon>
  </div>

  <h4
    id="informacje"
    [translation]="TranslationEnum.Translation">
    {{ 'informacje' | translate }}
  </h4>

</div>

<div class="footer-links">

  <ng-container *ngFor="let dok of tresci.links">

    <a
      *ngIf="
        dok.ProdGroup == 'b2b_informacje' &&
        dok.Culture == tresci.jezyk
      "
      [href]="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      {{ dok.LangVal }}

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>

  </ng-container>
<a
      
      href="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      Test linku

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>
<a
      
      href="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      Test linku

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>
<a
      
      href="dok.Url"
      rel="nofollow noopener"
      target="_blank">

      Test linku

      <mat-icon fontSet="material-icons">
        open_in_new
      </mat-icon>

    </a>
</div>

</div>

</div>


<!-- =====================================================
     DRUGI WIERSZ
     DANE FIRMY | COPYRIGHT / ALUPROF
     ===================================================== -->

<div class="footer-bottom">

  <!-- LEWA POŁOWA -->
  <div class="footer-company">

    <div class="footer-company-details">

      <span>
        KRS: 0000106225
      </span>

      <span class="company-detail-separator"></span>

      <span>
        NIP: 547-02-42-884
      </span>

      <span class="company-detail-separator"></span>

      <span>
        Kapitał zakładowy/wpłacony:
        4 028 350 PLN
      </span>

    </div>

    <div class="footer-company-details">

      <span>
        Sąd Rejonowy w Bielsku-Białej
      </span>

      <span class="company-detail-separator"></span>

      <span>
        VIII Wydział Gospodarczy KRS
      </span>

    </div>

    <div class="footer-company-details delivery-address">

      <mat-icon>
        mail
      </mat-icon>

      <span>
        Adres do e-doręczeń:
        AE:PL-96706-42023-SSEVB-21
      </span>

    </div>

  </div>


  <!-- PIONOWA KRESKA -->
  <div class="footer-bottom-divider"></div>


  <!-- PRAWA POŁOWA -->
  <div class="footer-bottom-right">

    <div class="footer-status-dot"></div>

    <span class="footer-copyright">
      © {{ dateInFooter }} b2b.aluprof.com
    </span>

    <span class="footer-separator"></span>

    <span class="footer-powered">
      powered by
    </span>

    <a
      href="https://www.aluprof.com"
      target="_blank"
      rel="noopener noreferrer"
      class="footer-aluprof-link">
      Aluprof
    </a>

    <span class="footer-version">
      v. {{ Version }}
    </span>

  </div>

</div>


  </div>

</footer>
